import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { Members } from './pages/members/Members';
import { Services } from './pages/services/Services';
import { AccessRights } from './pages/access/AccessRights';
import { Traffic } from './pages/traffic/Traffic';
import { Topology } from './pages/topology/Topology';
import { Shell, type NavItem } from './ui/Shell';

const NAV: NavItem[] = [
  { to: '/members', label: 'Members', icon: '◈' },
  { to: '/services', label: 'Services', icon: '▧' },
  { to: '/access-rights', label: 'Access Rights', icon: '⇄' },
  { to: '/traffic', label: 'Traffic', icon: '≈' },
  { to: '/topology', label: 'Topology', icon: '▦' },
];

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Shell title={persona.org} items={NAV} />}>
        <Route index element={<Navigate to="/members" replace />} />
        <Route path="members" element={<Members />} />
        <Route path="services" element={<Services />} />
        <Route path="access-rights" element={<AccessRights />} />
        <Route path="traffic" element={<Traffic />} />
        <Route path="topology" element={<Topology />} />
        <Route path="*" element={<Navigate to="/members" replace />} />
      </Route>
    </Routes>
  );
}
